import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import $ from "jquery";
// import { Paginator } from 'primereact/paginator';
import Moment from "moment";
import {
  UploadHKC,
  UploadEUSSR,
  UploadFullManual,
  Uploadec,
  Uploadldafd,
  Uploadamp,
  UploadDocument,
  UploadRevisionDocument,
  UploadInventoryDocument,
  UploadInventory,
  UploadFlagSoc,
  UploadIAPP,
} from "../Actions/CommonAPI";
import {
  postInventoryDetails,
  getShipManagementList,
} from "../Actions/ShipManagementAPI";
import { getCompanynameList, getCompanyUsersList } from "../Actions/HelpersAPI";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

let user = JSON.parse(localStorage.getItem("currentUser"));
var today = new Date();
var currentDate = Moment(new Date(Date.parse(today))).format("YYYY-MM-DD");
// var currentDate = moment(today).format("DD MMM YYYY");
let searchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 25,
};
class ShipManagementNewItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLRFromApplicable: false,
      NotLRFromApplicable: false,
      hkcfile: "",
      eussrfile: "",
      fullManualfile: "",
      flagSocfile: "",
      iappfile: "",
      ecfile: "",
      ldafdfile: "",
      ampfile: "",
      inventoryfile: "",
      revisionfile: "",
      revisionFilename: "",
      inventoryFilename: "",
      hkcFilename: "",
      eussrFilename: "",
      fullManualFilename: "",
      flagSocFilename: "",
      iappFilename: "",
      ecFilename: "",
      ldafdFilename: "",
      ampFilename: "",
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      ihmFromDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
      ldafdFromDateOpen: false,
      PreparationDateOpen: false,
      DeliveryDateOpen: false,
      shipData: {
        clientName: "",
        shipName: "",
        imoNo: "",
        flagName: "",
        className: "",
        shipEmail: "",
        dateOfBuild: "",
        poPullDate: "",
        vesselGroupEmail: "",
        invoiceForwardingEmail: "",
        phone1: "",
        phone2: "",
        hkcIssuedBy: "",
        hkcIssuedDate: "",
        fullmannualAttachmentName: "",
        fullmannualAttachmentGuid: "",
        flagSocAttachmentName: "",
        flagSocAttachmentGuid: "",
        IAPPAttachmentName: "",
        IAPPAttachmentGuid: "",
        ecAttachmentName: "",
        ecAttachmentGuid: "",
        ldafdAttachmentName: "",
        ldafdAttachmentGuid: "",
        ampAttachmentName: "",
        ampAttachmentGuid: "",
        eussrAttachmentName: "",
        eussrAttachmentGuid: "",
        hkcAttachmentName: "",
        hkcAttachmentGuid: "",
        hkcExpiryDate: "",
        euSSRIssuedBy: "",
        euSSRIssuedDate: "",
        euSSRExpiryDate: "",
        fullmannualIssuedDate: "",
        flagIssuedBy: "",
        flagIssuedDate: "",
        flagExpiryDate: "",
        iappIssuedDate: "",
        iappExpiryDate: "",
        ecIssuedDate: "",
        ecExpiryDate: "",
        ldafdIssuedDate: "",
        createdBy: user.email,
        shipUsers: [],
        attachmentName: "",
        attachmentGuid: "",
        inventoryName: "",
        inventoryGuid: "",
        designatedPerson: ""
      },
      file: "",
      activePagePaintCoating: 0,
      activePageEquipment: 0,
      activePageStructure: 0,
      activePageStore: 0,
      rows: 5,
      fleetManager: "",
      technicalSuperintendent: "",
      technicalExecutive: "",
      paintAndCoating: [],
      equipmentAndMachinery: [],
      structureAndHull: [],
      store: [],
      isActive: false,
      persons: [],
      lrForm: {
        vesselName: "",
        distinctiveNo: "",
        portOfRegistry: "",
        typeOfVessel: "",
        grossTonnage: "",
        imonumber: "",
        nameOfShipBuilder: "",
        nameOfShipOwner: "",
        dateOfDelivery: "",
        ihmInventoryNumber: "",
        issueNumber: "",
        isIhmDeveloped: false,
        nameOfPreparer: "",
        initialOfPreparer: "",
        companyOfPreparer: "",
        addressOfPreparer: "",
        positionOfPreparer: "",
        dateOfPreparation: "",
        createdBy: user.email,
      },
      isMobile: false,
    };
    this.handleCompanyInputChange = this.handleCompanyInputChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.openEnrollmentDatePicker = this.openEnrollmentDatePicker.bind(this);
    this.openPODatePicker = this.openPODatePicker.bind(this);
    this.openHKCFromDatePicker = this.openHKCFromDatePicker.bind(this);
    this.openEUSSRFromDatePicker = this.openEUSSRFromDatePicker.bind(this);
    this.openFlagSocFromDatePicker = this.openFlagSocFromDatePicker.bind(this);
    this.openHKCToDatePicker = this.openHKCToDatePicker.bind(this);
    this.openEUSSRToDatePicker = this.openEUSSRToDatePicker.bind(this);
    this.openFlagSocToDatePicker = this.openFlagSocToDatePicker.bind(this);
    this.openIHMFromDatePicker = this.openIHMFromDatePicker.bind(this);
    this.handleEnrollmentDateChange =
      this.handleEnrollmentDateChange.bind(this);
    this.handlePODateChange = this.handlePODateChange.bind(this);
    this.handleHKCFromDateChange = this.handleHKCFromDateChange.bind(this);
    this.handleHKCToDateChange = this.handleHKCToDateChange.bind(this);
    this.handleEUSSRFromDateChange = this.handleEUSSRFromDateChange.bind(this);
    this.handleEUSSRToDateChange = this.handleEUSSRToDateChange.bind(this);
    this.handleFlagSocFromDateChange =
      this.handleFlagSocFromDateChange.bind(this);
    this.handleFlagSocToDateChange = this.handleFlagSocToDateChange.bind(this);
    this.handleIHMFromDateChange = this.handleIHMFromDateChange.bind(this);
    this.handlePaintCoatingPageChange =
      this.handlePaintCoatingPageChange.bind(this);
    this.handleEquipmentPageChange = this.handleEquipmentPageChange.bind(this);
    this.handleStructurePageChange = this.handleStructurePageChange.bind(this);
    this.handleStoresPageChange = this.handleStoresPageChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Management" });
    dispatch(getCompanynameList());
    this.interval = setInterval(() => {
      this.resize();
    }, 10);
  }
  resize = () => {
    if (window.innerWidth < 1007) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      dispatch,
      attachmentDetail,
      inventoryDetail,
      HKCAttachment,
      EUSSRAttachment,
      PaintCoatingList,
      EquipmentMachineryList,
      StructureHullList,
      StoreList,
      FullManualAttachment,
      FlagSOCAttachment,
      IAPPAttachment,
      AMPAttachment,
      ECAttachment,
      LDSFAAttachment,
    } = nextProps;
    if (attachmentDetail && attachmentDetail !== "") {
      prevState.shipData.attachmentName = attachmentDetail.FileName;
      prevState.shipData.attachmentGuid = attachmentDetail.Guid;
      dispatch({ type: "AttachmentUploadSuccess", data: "" });
    }
    if (inventoryDetail && inventoryDetail !== "") {
      prevState.shipData.inventoryName = inventoryDetail.FileName;
      prevState.shipData.inventoryGuid = inventoryDetail.Guid;
      dispatch({ type: "InventoryUploadSuccess", data: "" });
    }
    if (HKCAttachment && HKCAttachment !== "") {
      prevState.shipData.hkcAttachmentName = HKCAttachment.FileName;
      prevState.shipData.hkcAttachmentGuid = HKCAttachment.Guid;
      dispatch({ type: "AttachmentUploadHKCSuccess", data: "" });
    }
    if (EUSSRAttachment && EUSSRAttachment !== "") {
      prevState.shipData.eussrAttachmentName = EUSSRAttachment.FileName;
      prevState.shipData.eussrAttachmentGuid = EUSSRAttachment.Guid;
      dispatch({ type: "AttachmentUploadEUSSRSuccess", data: "" });
    }
    if (FullManualAttachment && FullManualAttachment !== "") {
      prevState.shipData.fullmannualAttachmentName =
        FullManualAttachment.FileName;
      prevState.shipData.fullmannualAttachmentGuid = FullManualAttachment.Guid;
      dispatch({ type: "AttachmentUploadFullManualSuccess", data: "" });
    }
    if (FlagSOCAttachment && FlagSOCAttachment !== "") {
      prevState.shipData.flagSocAttachmentName = FlagSOCAttachment.FileName;
      prevState.shipData.flagSocAttachmentGuid = FlagSOCAttachment.Guid;
      dispatch({ type: "AttachmentUploadFlagSOCSuccess", data: "" });
    }
    if (ECAttachment && ECAttachment !== "") {
      prevState.shipData.ecAttachmentName = ECAttachment.FileName;
      prevState.shipData.ecAttachmentGuid = ECAttachment.Guid;
      dispatch({ type: "AttachmentUploadecSuccess", data: "" });
    }
    if (LDSFAAttachment && LDSFAAttachment !== "") {
      prevState.shipData.ldafdAttachmentName = LDSFAAttachment.FileName;
      prevState.shipData.ldafdAttachmentGuid = LDSFAAttachment.Guid;
      dispatch({ type: "AttachmentUploadldafdSuccess", data: "" });
    }
    if (AMPAttachment && AMPAttachment !== "") {
      prevState.shipData.ampAttachmentName = AMPAttachment.FileName;
      prevState.shipData.ampAttachmentGuid = AMPAttachment.Guid;
      dispatch({ type: "AttachmentUploadampSuccess", data: "" });
    }
    if (IAPPAttachment && IAPPAttachment !== "") {
      prevState.shipData.IAPPAttachmentName = IAPPAttachment.FileName;
      prevState.shipData.IAPPAttachmentGuid = IAPPAttachment.Guid;
      dispatch({ type: "AttachmentUploadIAPPSuccess", data: "" });
    }
    if (prevState.hkcfile !== "") {
      dispatch(UploadHKC(prevState.hkcfile));
      prevState.hkcfile = "";
    }
    if (prevState.eussrfile !== "") {
      dispatch(UploadEUSSR(prevState.eussrfile));
      prevState.eussrfile = "";
    }
    if (prevState.fullManualfile !== "") {
      dispatch(UploadFullManual(prevState.fullManualfile));
      prevState.fullManualfile = "";
    }
    if (prevState.flagSocfile !== "") {
      dispatch(UploadFlagSoc(prevState.flagSocfile));
      prevState.flagSocfile = "";
    }
    if (prevState.iappfile !== "") {
      dispatch(UploadIAPP(prevState.iappfile));
      prevState.iappfile = "";
    }
    if (prevState.ecfile !== "") {
      dispatch(Uploadec(prevState.ecfile));
      prevState.ecfile = "";
    }
    if (prevState.ldafdfile !== "") {
      dispatch(Uploadldafd(prevState.ldafdfile));
      prevState.ldafdfile = "";
    }
    if (prevState.ampfile !== "") {
      dispatch(Uploadamp(prevState.ampfile));
      prevState.ampfile = "";
    }
    if (prevState.revisionfile !== "") {
      dispatch(UploadDocument(prevState.revisionfile));
      prevState.revisionfile = "";
    }
    if (prevState.inventoryfile !== "") {
      dispatch(UploadInventoryDocument(prevState.inventoryfile));
      prevState.inventoryfile = "";
    }
    if (PaintCoatingList) {
      prevState.paintAndCoating = PaintCoatingList.map((f) => {
        let paint = {
          paintAndCoatingId: f.paintAndCoatingId,
          name: f.name,
          application: f.application,
          location: f.location,
          remarks: f.remarks,
          quantity: f.quantity,
          unit: f.unit,
          pchmchm: f.pchmchm,
          isDeleted: false,
          isUpdated: true,
          createdBy: user.email,
          modifiedBy: "",
        };
        return paint;
      });
    }
    if (EquipmentMachineryList) {
      prevState.equipmentAndMachinery = EquipmentMachineryList.map((g) => {
        let equip = {
          equipmentAndMachineryId: g.equipmentAndMachineryId,
          name: g.name,
          material: g.material,
          location: g.location,
          remarks: g.remarks,
          parts: g.parts,
          quantity: g.quantity,
          unit: g.unit,
          pchmchm: g.pchmchm,
          isDeleted: false,
          isUpdated: true,
          createdBy: user.email,
          modifiedBy: user.email,
        };
        return equip;
      });
    }
    if (StructureHullList) {
      prevState.structureAndHull = StructureHullList.map((h) => {
        let structure = {
          structureAndHullId: h.structureAndHullId,
          name: h.name,
          material: h.material,
          location: h.location,
          remarks: h.remarks,
          parts: h.parts,
          quantity: h.quantity,
          unit: h.unit,
          pchmchm: h.pchmchm,
          isDeleted: false,
          isUpdated: true,
          createdBy: user.email,
          modifiedBy: user.email,
        };
        return structure;
      });
    }
    if (StoreList) {
      prevState.store = StoreList.map((i) => {
        let store = {
          storeId: i.storeId,
          name: i.name,
          material: i.material,
          location: i.location,
          remarks: i.remarks,
          parts: i.parts,
          quantity: i.quantity,
          unit: i.unit,
          pchmchm: i.pchmchm,
          isDeleted: false,
          isUpdated: true,
          createdBy: user.email,
          modifiedBy: user.email,
        };
        return store;
      });
    }
  }

  SubmitData() {
    const { dispatch } = this.props;
    console.log("shipusers", this.state);
    if (
      this.state.shipData.shipName !== "" &&
      this.state.shipData.dateOfBuild !== "" &&
      this.state.shipData.poPullDate !== "" &&
      this.state.shipData.className !== "" &&
      this.state.shipData.flagName !== "" &&
      this.state.shipData.imoNo !== ""
    ) {
      if (
        // this.state.shipData.hkcAttachmentName !== "" &&
        this.state.shipData.shipEmail !== "" /* &&
        this.state.shipData.hkcIssuedDate !== "" &&
        this.state.shipData.hkcExpiryDate !== "" */
      ) {
        if (this.state.NotLRFromApplicable === true || this.state.isLRFromApplicable === true) {
          let testUrl = `${API.userExist}?Mail=${this.state.shipData.shipEmail}&Id=${0}`;
          axios
            .get(testUrl, {
              headers: {
                key: user.accessToken,
              },
            })
            .then((response) => {
              if (response.data === true) {
                if (this.state.shipData.fullmannualIssuedDate === "") {
                  this.state.shipData.fullmannualIssuedDate = currentDate;
                }


                let url = `${API.postShip}`;
                let data = {
                  ...this.state.shipData,
                  designatedPerson: this.state.shipData.designatedPerson.trim() ? this.state.shipData.designatedPerson : "",

                };
                axios
                  .post(url, data, {
                    headers: {
                      key: user.accessToken,
                    },
                  })
                  .then((response) => {
                    let data3 = {
                      shipId: response.data,
                      vesselName: this.state.lrForm.vesselName,
                      distinctiveNo: this.state.lrForm.distinctiveNo,
                      portOfRegistry: this.state.lrForm.portOfRegistry,
                      typeOfVessel: this.state.lrForm.typeOfVessel,
                      grossTonnage: this.state.lrForm.grossTonnage,
                      imonumber: this.state.lrForm.imonumber,
                      nameOfShipBuilder: this.state.lrForm.nameOfShipBuilder,
                      nameOfShipOwner: this.state.lrForm.nameOfShipOwner,
                      dateOfDelivery: this.state.lrForm.dateOfDelivery,
                      ihmInventoryNumber: this.state.lrForm.ihmInventoryNumber,
                      issueNumber: this.state.lrForm.issueNumber,
                      isIhmDeveloped: this.state.lrForm.isIhmDeveloped,
                      nameOfPreparer: this.state.lrForm.nameOfPreparer,
                      initialOfPreparer: this.state.lrForm.initialOfPreparer,
                      companyOfPreparer: this.state.lrForm.companyOfPreparer,
                      addressOfPreparer: this.state.lrForm.addressOfPreparer,
                      positionOfPreparer: this.state.lrForm.positionOfPreparer,
                      dateOfPreparation: this.state.lrForm.dateOfPreparation,
                      isApplicable: this.state.isLRFromApplicable === true ? true : false,
                      createdBy: user.email,
                    };
                    let url3 = `${API.GetLRForm}`;
                    axios
                      .post(url3, data3)
                      .then((result) => {
                        if (result.data) {
                          let data4 = {
                            shipLrFormId: result.data,
                            persons: this.state.persons,
                          };
                          let url4 = `${API.GetPersons}`;
                          axios
                            .post(url4, data4)
                            .then((result) => {
                              dispatch({
                                type: "postInventoryPersonSuccess",
                                data: result.data,
                              });
                            })
                            .catch((error) => {
                              dispatch({
                                type: "postInventoryPersonFailure",
                                error: "ERROR",
                              });
                            });
                        }
                        dispatch({
                          type: "postLRSuccess",
                          data: result.data,
                        });
                      })
                      .catch((error) => {
                        dispatch({
                          type: "postLRFailure",
                          error: "ERROR",
                        });
                      });
                    let data1 = {
                      shipId: response.data,
                      certificates: [
                        {
                          certificateType: "hkc",
                          certificateId: 0,
                          issuedDate: this.state.shipData.hkcIssuedDate,
                          expiryDate: this.state.shipData.hkcExpiryDate,
                          attachmentName: this.state.shipData.hkcAttachmentName,
                          attachmentGuid: this.state.shipData.hkcAttachmentGuid,
                        },
                        {
                          certificateType: "eussr",
                          certificateId: 0,
                          issuedDate: this.state.shipData.euSSRIssuedDate,
                          expiryDate: this.state.shipData.euSSRExpiryDate,
                          attachmentName: this.state.shipData.eussrAttachmentName,
                          attachmentGuid: this.state.shipData.eussrAttachmentGuid,
                        },
                        {
                          certificateType: "flagsoc",
                          certificateId: 0,
                          issuedDate: this.state.shipData.flagIssuedDate,
                          expiryDate: this.state.shipData.flagExpiryDate,
                          attachmentName:
                            this.state.shipData.flagSocAttachmentName,
                          attachmentGuid:
                            this.state.shipData.flagSocAttachmentGuid,
                        },
                        {
                          certificateType: "initialfullmannual",
                          certificateId: 0,
                          issuedDate: this.state.shipData.fullmannualIssuedDate,
                          expiryDate: "",
                          attachmentName:
                            this.state.shipData.fullmannualAttachmentName,
                          attachmentGuid:
                            this.state.shipData.fullmannualAttachmentGuid,
                        },
                        {
                          certificateType: "iapp",
                          certificateId: 0,
                          issuedDate: this.state.shipData.iappIssuedDate,
                          expiryDate: this.state.shipData.iappExpiryDate,
                          attachmentName: this.state.shipData.IAPPAttachmentName,
                          attachmentGuid: this.state.shipData.IAPPAttachmentGuid,
                        },
                        {
                          certificateType: "exemptioncertificate",
                          certificateId: 0,
                          issuedDate: this.state.shipData.ecIssuedDate,
                          expiryDate: this.state.shipData.ecExpiryDate,
                          attachmentName: this.state.shipData.ecAttachmentName,
                          attachmentGuid: this.state.shipData.ecAttachmentGuid,
                        },
                        {
                          certificateType: "asbestosfreedeclaration",
                          certificateId: 0,
                          issuedDate: this.state.shipData.ldafdIssuedDate,
                          expiryDate: null,
                          attachmentName: this.state.shipData.ldafdAttachmentName,
                          attachmentGuid: this.state.shipData.ldafdAttachmentGuid,
                        },
                        {
                          certificateType: "asbestosplan",
                          certificateId: 0,
                          issuedDate: null,
                          expiryDate: null,
                          attachmentName: this.state.shipData.ampAttachmentName,
                          attachmentGuid: this.state.shipData.ampAttachmentGuid,
                        },
                      ],
                      createdBy: user.email,
                    };
                    let url1 = `${API.Certificates}`;
                    axios
                      .post(url1, data1)
                      .then((res) => {
                        dispatch({
                          type: "postCertificateSuccess",
                          data: res.data,
                        });
                      })
                      .catch((error) => {
                        dispatch({
                          type: "postCertificateFailure",
                          error: "ERROR",
                        });
                      });
                    let data2 = {
                      shipId: response.data,
                      pullDate: this.state.shipData.poPullDate
                        ? this.state.shipData.poPullDate
                        : "",
                    };
                    let url2 = `${API.pullDate}`;
                    axios
                      .put(url2, data2)
                      .then((res) => {
                        dispatch({
                          type: "postPullDateSuccess",
                          data: res.data,
                        });
                      })
                      .catch((error) => {
                        dispatch({
                          type: "postPullDateFailure",
                          error: "ERROR",
                        });
                      });
                    let inventory = {
                      shipId: response.data,
                      paintAndCoating: this.state.paintAndCoating,
                      equipmentAndMachinery: this.state.equipmentAndMachinery,
                      structureAndHull: this.state.structureAndHull,
                      store: this.state.store,
                    };
                    let upload = {
                      shipId: response.data,
                      attachmentName: this.state.shipData.attachmentName,
                      attachmentGuid: this.state.shipData.attachmentGuid,
                    };
                    let inventoryDocument = {
                      shipId: response.data,
                      attachmentName: this.state.shipData.inventoryName,
                      attachmentGuid: this.state.shipData.inventoryGuid,
                    };
                    if (
                      inventory.paintAndCoating.length !== 0 ||
                      inventory.equipmentAndMachinery.length !== 0 ||
                      inventory.structureAndHull.length !== 0 ||
                      inventory.store.length !== 0
                    ) {
                      dispatch(postInventoryDetails(inventory));
                    }
                    if (
                      this.state.shipData.attachmentName &&
                      this.state.shipData.attachmentGuid
                    ) {
                      dispatch(UploadRevisionDocument(upload));
                    }
                    if (
                      this.state.shipData.inventoryName &&
                      this.state.shipData.inventoryGuid
                    ) {
                      dispatch(UploadInventory(inventoryDocument));
                    }
                    this.props.history.push("/Home/Management/Ship");
                    toast.success("Added Successfully", {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                    this.props.dispatch({ type: "ShowSidePan", data: false });
                    dispatch(getShipManagementList(searchData));
                    dispatch({
                      type: "postShipDetailsSuccess",
                      data: response.data,
                    });
                  })
                  .catch((error) => {
                    dispatch({
                      type: "postShipDetailsFailure",
                      error: "ERROR",
                    });
                  });
              } else {
                swal("Error!", "Ship email is Aleardy Exists", "warning");
              }
            });
        } else {
          swal("Error!", "Please select the LRFrom applicable type.", "warning");
        }
      } /* else if (this.state.shipData.hkcAttachmentName === "") {
        swal("Error!", "HKC Attachment is mandatory", "warning");
      } else if (this.state.shipData.hkcIssuedDate === "") {
        swal("Error!", "HKC Issued Date is mandatory", "warning");
      } else if (this.state.shipData.hkcExpiryDate === "") {
        swal("Error!", "HKC Expriry Date is mandatory", "warning");
      }  */ else if (this.state.shipData.shipEmail === "") {
        swal("Error!", "Ship Email is mandatory", "warning");
      }
    } else if (this.state.shipData.shipName === "") {
      swal("Error!", "Ship Name is mandatory", "warning");
    } else if (this.state.shipData.imoNo === "") {
      swal("Error!", "IMO Number is mandatory", "warning");
    } else if (this.state.shipData.flagName === "") {
      swal("Error!", "Flag Name is mandatory", "warning");
    } else if (this.state.shipData.className === "") {
      swal("Error!", "Class Name is mandatory", "warning");
    } else if (this.state.shipData.dateOfBuild === "") {
      swal("Error!", "Enrollment Date is mandatory", "warning");
    } else if (this.state.shipData.poPullDate === "") {
      swal("Error!", "PO Pull Date is mandatory", "warning");
    }
  }

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Ship");
  };

  handleCompanyInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fleetManager") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "fleetmanager",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "technicalSuperintendent") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "superintendent",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "technicalExecutive") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "technicalexecutive",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "clientName") {
      this.props.dispatch(getCompanyUsersList(e.target.value));
      this.state.shipData[nodeName] = e.target.value;
      this.state.fleetManager = "";
      this.state.technicalSuperintendent = "";
      this.state.technicalExecutive = "";
      this.state.shipData.shipUsers = [];
    } else {
      this.state.shipData[nodeName] = e.target.value;
    }
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "HKC") {
      this.state.hkcFilename = e.target.files[0].name;
      this.state.hkcfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "EUSSR") {
      this.state.eussrFilename = e.target.files[0].name;
      this.state.eussrfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "fullManual") {
      this.state.fullManualFilename = e.target.files[0].name;
      this.state.fullManualfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "SOC") {
      this.state.flagSocFilename = e.target.files[0].name;
      this.state.flagSocfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "IAPP") {
      this.state.iappFilename = e.target.files[0].name;
      this.state.iappfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "ec") {
      this.state.ecFilename = e.target.files[0].name;
      this.state.ecfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "ldafd") {
      this.state.ldafdFilename = e.target.files[0].name;
      this.state.ldafdfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "amp") {
      this.state.ampFilename = e.target.files[0].name;
      this.state.ampfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "fileName") {
      this.state.revisionFilename = e.target.files[0].name;
      this.state.revisionfile = e.target.files[0];
      this.setState({});
      // this.props.dispatch(UploadDocument(e.target.files[0]));
    } else if (nodeName === "inventoryName") {
      this.state.inventoryFilename = e.target.files[0].name;
      this.state.inventoryfile = e.target.files[0];
      this.setState({});
      // this.props.dispatch(UploadInventoryDocument(e.target.files[0]));
    } else {
      this.state.shipData[nodeName] = e.target.value;
      this.setState({});
    }
  }

  handleLRChange = (e) => {
    let nodeName = e.target.name;
    this.state.lrForm[nodeName] = e.target.value;
    this.setState({});
  };

  handleCheckBoxChange = (e) => {
    if (e.target.checked) {
      this.state.lrForm.isIhmDeveloped = true;
      this.setState({});
    } else {
      this.state.lrForm.isIhmDeveloped = false;
      this.setState({});
    }
  };

  handleAddEvent = (e) => {
    var person = {
      inventoryResponsiblePersonId: 0,
      name: "",
      position: "",
      initials: "",
      startDate: "",
      endDate: "",
      isDeleted: false,
      createdBy: user.email,
    };
    this.state.persons.push(person);
    this.setState(this.state.persons);
  };

  handleTableEvent = (e, index, field) => {
    this.state.persons[index][field] = e.target.outerText;
    this.setState({});
  };

  handleDeleteEvent = (e, index) => {
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.persons.splice(index, 1);
            this.setState({});
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  // ClearInput() {
  //     this.state.shipData.attachmentName = '';
  //     this.state.shipData.attachmentGuid = '';
  //     let clearData = { FileName: "", Guid: "" }
  //     this.props.dispatch({
  //         type: "AttachmentUploadSuccess",
  //         data: clearData,
  //     })
  // }

  ClearInput = () => {
    this.state.shipData.attachmentName = "";
    this.state.shipData.attachmentGuid = "";
    const { dispatch } = this.props;
    this.setState({
      revisionFilename: "",
      revisionfile: "",
    });
    dispatch({ type: "AttachmentUploadSuccess", data: "" });
  };

  ClearInputs = () => {
    this.state.shipData.inventoryName = "";
    this.state.shipData.inventoryGuid = "";
    const { dispatch } = this.props;
    this.setState({
      inventoryFilename: "",
      inventoryfile: "",
    });
    dispatch({ type: "InventoryUploadSuccess", data: "" });
  };

  handleRadioInputChange(e, name) {
    let nodeName = name;
    if (nodeName === "Yes") {
      $("#LRFromApplicable").addClass("show")
      this.setState({ isLRFromApplicable: true, NotLRFromApplicable: false });
    } else if (nodeName === "No") {
      $("#LRFromApplicable").removeClass("show")
      this.setState({ isLRFromApplicable: false, NotLRFromApplicable: true });
    }
  }
  openHKCFromDatePicker() {
    this.setState({
      hkcFromDateOpen: !this.state.hkcFromDateOpen,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openEUSSRFromDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: !this.state.eussrFromDateOpen,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openHKCToDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: !this.state.hkcToDateOpen,
      eussrFromDateOpen: false,
      ihmFromDateOpen: false,
      enrollmentDateOpen: false,
      eussrToDateOpen: false,
      PODateOpen: false,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openEUSSRToDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      ihmFromDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      eussrToDateOpen: !this.state.eussrToDateOpen,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openIHMFromDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      ihmFromDateOpen: !this.state.ihmFromDateOpen,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openEnrollmentDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      enrollmentDateOpen: !this.state.enrollmentDateOpen,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openPODatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      ihmFromDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: !this.state.PODateOpen,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openFlagSocFromDatePicker() {
    this.setState({
      flagSocFromDateOpen: !this.state.flagSocFromDateOpen,
      flagSocToDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openFlagSocToDatePicker() {
    this.setState({
      flagSocToDateOpen: !this.state.flagSocToDateOpen,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openecFromDatePicker = () => {
    this.setState({
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecToDateOpen: false,
      ecFromDateOpen: !this.state.ecFromDateOpen,
    });
  };

  openldafdFromDatePicker = () => {
    this.setState({
      flagSocToDateOpen: false,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
      ldafdFromDateOpen: !this.state.ldafdFromDateOpen,
    });
  };

  openecToDatePicker = () => {
    this.setState({
      flagSocToDateOpen: false,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: !this.state.ecToDateOpen,
    });
  };

  openiappFromDatePicker = () => {
    this.setState({
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
      iappToDateOpen: false,
      iappFromDateOpen: !this.state.iappFromDateOpen,
    });
  };

  openiappToDatePicker = () => {
    this.setState({
      flagSocToDateOpen: false,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: !this.state.iappToDateOpen,
    });
  };

  handleBlur() {
    this.setState({
      flagSocToDateOpen: false,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      DeliveryDateOpen: false,
      PreparationDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
    });
  }

  openDeliveryDatePicker = () => {
    this.setState({
      PreparationDateOpen: false,
      DeliveryDateOpen: !this.state.DeliveryDateOpen,
    });
  };

  openPreparationDatePicker = () => {
    this.setState({
      DeliveryDateOpen: false,
      PreparationDateOpen: !this.state.PreparationDateOpen,
    });
  };

  handleEnrollmentDateChange(date) {
    this.state.shipData.dateOfBuild = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      enrollmentDateOpen: false,
    });
  }

  handlePODateChange(date) {
    this.state.shipData.poPullDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      PODateOpen: false,
    });
  }

  handleHKCFromDateChange(date) {
    this.state.shipData.hkcIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      hkcFromDateOpen: false,
    });
  }

  handleHKCToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.hkcIssuedDate
    ) {
      this.state.shipData.hkcExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      hkcToDateOpen: false,
    });
  }

  handleEUSSRFromDateChange(date) {
    this.state.shipData.euSSRIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      eussrFromDateOpen: false,
    });
  }

  handleEUSSRToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.euSSRIssuedDate
    ) {
      this.state.shipData.euSSRExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      eussrToDateOpen: false,
    });
  }

  handleIHMFromDateChange(date) {
    this.state.shipData.fullmannualIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      ihmFromDateOpen: false,
    });
  }

  handleFlagSocFromDateChange(date) {
    this.state.shipData.flagIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      flagSocFromDateOpen: false,
    });
  }

  handleFlagSocToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.flagIssuedDate
    ) {
      this.state.shipData.flagExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      flagSocToDateOpen: false,
    });
  }

  handleiappFromDateChange = (date) => {
    this.state.shipData.iappIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      iappFromDateOpen: false,
    });
  };

  handleiappToDateChange = (date) => {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.iappIssuedDate
    ) {
      this.state.shipData.iappExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      iappToDateOpen: false,
    });
  };

  handleecFromDateChange = (date) => {
    this.state.shipData.ecIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      ecFromDateOpen: false,
    });
  };

  handleecToDateChange = (date) => {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.ecIssuedDate
    ) {
      this.state.shipData.ecExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      ecToDateOpen: false,
    });
  };

  handleldafdFromDateChange = (date) => {
    this.state.shipData.ldafdIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      ldafdFromDateOpen: false,
    });
  };

  handlePreparationDateChange = (date) => {
    this.state.lrForm.dateOfPreparation = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      PreparationDateOpen: false,
    });
  };

  handleDeliveryDateChange = (date) => {
    this.state.lrForm.dateOfDelivery = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      DeliveryDateOpen: false,
    });
  };

  ClearHKC = () => {
    const { dispatch } = this.props;
    this.state.shipData.hkcAttachmentName = "";
    this.state.shipData.hkcAttachmentGuid = "";
    this.state.shipData.hkcIssuedDate = "";
    this.state.shipData.hkcExpiryDate = "";
    this.setState({
      hkcFilename: "",
      hkcfile: "",
    });
  };

  ClearEUSSR = () => {
    const { dispatch } = this.props;
    this.state.shipData.eussrAttachmentName = "";
    this.state.shipData.eussrAttachmentGuid = "";
    this.state.shipData.euSSRIssuedDate = "";
    this.state.shipData.euSSRExpiryDate = "";
    this.setState({
      eussrfile: "",
      eussrFilename: "",
    });
  };

  ClearIHM = () => {
    const { dispatch } = this.props;
    this.state.shipData.fullmannualAttachmentName = "";
    this.state.shipData.fullmannualAttachmentGuid = "";
    this.state.shipData.fullmannualIssuedDate = "";
    this.setState({
      fullManualFile: "",
      fullManualFilename: "",
    });
  };

  ClearSOC = () => {
    const { dispatch } = this.props;
    this.state.shipData.flagSocAttachmentName = "";
    this.state.shipData.flagSocAttachmentGuid = "";
    this.state.shipData.flagIssuedDate = "";
    this.state.shipData.flagExpiryDate = "";
    this.setState({
      flagSocFilename: "",
      flagSocfile: "",
    });
  };

  Clearamp = () => {
    const { dispatch } = this.props;
    this.state.shipData.ampAttachmentName = "";
    this.state.shipData.ampAttachmentGuid = "";
    this.setState({
      ampFilename: "",
      ampfile: "",
    });
  };

  Clearec = () => {
    const { dispatch } = this.props;
    this.state.shipData.ecAttachmentName = "";
    this.state.shipData.ecAttachmentGuid = "";
    this.state.shipData.ecIssuedDate = "";
    this.state.shipData.ecExpiryDate = "";
    this.setState({
      ecFilename: "",
      ecfile: "",
    });
  };

  Clearldafd = () => {
    const { dispatch } = this.props;
    this.state.shipData.ldafdAttachmentName = "";
    this.state.shipData.ldafdAttachmentGuid = "";
    this.state.shipData.ldafdIssuedDate = "";
    this.setState({
      ldafdFilename: "",
      ldafdfile: "",
    });
  };

  ClearIAPP = () => {
    const { dispatch } = this.props;
    this.state.shipData.IAPPAttachmentName = "";
    this.state.shipData.IAPPAttachmentGuid = "";
    this.state.shipData.iappIssuedDate = "";
    this.state.shipData.iappExpiryDate = "";
    this.setState({
      iappFilename: "",
      iappfile: "",
    });
  };

  handlePaintCoatingPageChange(event) {
    this.setState({
      activePagePaintCoating: event.first,
    });
  }

  handleEquipmentPageChange(event) {
    this.setState({
      activePageEquipment: event.first,
    });
  }

  handleStructurePageChange(event) {
    this.setState({
      activePageStructure: event.first,
    });
  }

  handleStoresPageChange(event) {
    this.setState({
      activePageStore: event.first,
    });
  }

  toggleVisibility = () =>
    this.setState((prevState) => ({ isActive: !this.state.isActive }));

  render() {
    const { showSidePane, CompanyNames, CompanyUsers } = this.props;
    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="search-filter-box pb-0">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Basic Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Ship Name</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="shipName"
                      placeholder="Ship Name"
                      value={this.state.shipData.shipName}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  {/* <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                                        <label className="form-label" >Client Name</label><br></br>
                                        <input className="form-control" type="text" name="clientName" placeholder="Client Name" value={this.state.shipData.clientName} onChange={e => this.handleInputChange(e)}></input>
                                    </div> */}
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">IMO No</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="imoNo"
                      placeholder="IMO No"
                      value={this.state.shipData.imoNo}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Flag</label>
                    <br></br>
                    <input
                      className="form-control"
                      placeholder="Flag"
                      name="flagName"
                      value={this.state.shipData.flagName}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                    {/* <select className="form-control" name="flagName" value={this.state.shipData.flagName} onChange={e => this.handleInputChange(e)}>
                                            <option value="">Select Flag</option>
                                            <option value="Flag 1">Flag 1</option>
                                            <option value="Flag 2">Flag 2</option>
                                            <option value="Flag 3">Flag 3</option>
                                            <option value="Flag 4">Flag 4</option>
                                        </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Class</label>
                    <br></br>
                    <input
                      className="form-control"
                      placeholder="Class"
                      name="className"
                      value={this.state.shipData.className}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                    {/* <select className="form-control" name="className" value={this.state.shipData.className} onChange={e => this.handleInputChange(e)}>
                                            <option value="">Select Class</option>
                                            <option value="Class 1">Class 1</option>
                                            <option value="Class 2">Class 2</option>
                                            <option value="Class 3">Class 3</option>
                                            <option value="Class 4">Class 4</option>
                                        </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">
                      Enrollment Date
                    </label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.dateOfBuild}
                        className="form-control date-picker required"
                        placeholder="Enrollment Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        // selected={this.state.SelectedFromDate}
                        onChange={this.handleEnrollmentDateChange}
                        open={this.state.enrollmentDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openEnrollmentDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">PO Pull Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.poPullDate}
                        className="form-control date-picker"
                        placeholder="PO Pull Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handlePODateChange}
                        open={this.state.PODateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openPODatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="search-filter-box pb-0">
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <div className="panel-box">
                      <Accordion>
                        <Card
                          className={"MM-card-header"}
                          style={{ backgroundColor: "white" }}
                        >
                          <Accordion.Toggle
                            as={Card.Body}
                            style={{ cursor: "pointer" }}>
                            <h5
                              className="card-title ml-2 mt-2"
                              style={{ color: "092a51" }}>
                              <div className="row">
                                <span className="pl-3">LR Form</span>{" "}
                                <span className="pl-5">Is Applicable </span>
                                <div className="col-sm-3 d-flex">
                                  <input
                                    type="radio"
                                    name="LRFROM"
                                    checked={this.state.isLRFromApplicable}
                                    onChange={(e) =>
                                      this.handleRadioInputChange(e, "Yes")
                                    }
                                  ></input>
                                  <span className="ml-1">Yes</span>
                                  <label className="pl-4 m-0 d-flex">
                                    <input
                                      type="radio"
                                      name="LRFROM"
                                      checked={this.state.NotLRFromApplicable}
                                      onChange={(e) =>
                                        this.handleRadioInputChange(e, "No")
                                      }
                                    ></input>
                                    <span className="ml-1">No</span></label>
                                </div>

                              </div>
                            </h5>
                          </Accordion.Toggle>
                          <Accordion.Collapse className="" id="LRFromApplicable">
                            <div className="search-filter-box history-box mt-2">
                              <div
                                className="card mt-2 MM-card-header mb-0"
                                style={{ backgroundColor: "white" }}
                              >
                                <div
                                  className="card-body text-center"
                                  style={{
                                    padding: "0rem",
                                    backgroundColor: "#1E3A8A",
                                    color: "white",
                                  }}
                                >
                                  <h5
                                    className="card-title m-2"
                                    style={{ color: "092a51" }}
                                  >
                                    Inventory of Hazardous Materials
                                  </h5>
                                </div>
                              </div>
                              <div className="row search-filter-box">
                                <div className="col-lg-12">
                                  <strong style={{ fontSize: "20px" }}>
                                    Particulars of the Ship:{" "}
                                  </strong>
                                  <br></br>
                                  <i>
                                    <b>
                                      (Fields with a{" "}
                                      <span style={{ color: "red" }}>*</span>{" "}
                                      are mandatory and must be completed in all
                                      cases.)
                                    </b>
                                  </i>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Ship/Vessel Name{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Ship/Vessel Name"
                                    name="vesselName"
                                    value={this.state.lrForm.vesselName}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Distinctive No. / Letters{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Distinctive No. / Letters"
                                    name="distinctiveNo"
                                    value={this.state.lrForm.distinctiveNo}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Port of Registry{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Port of Registry"
                                    name="portOfRegistry"
                                    value={this.state.lrForm.portOfRegistry}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Type of vessel{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Type of vessel"
                                    name="typeOfVessel"
                                    value={this.state.lrForm.typeOfVessel}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Gross Tonnage{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Gross Tonnage"
                                    name="grossTonnage"
                                    value={this.state.lrForm.grossTonnage}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    IMO Number{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="IMO Number"
                                    name="imonumber"
                                    value={this.state.lrForm.imonumber}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Name of Shipbuilder{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Name of Shipbuilder"
                                    name="nameOfShipBuilder"
                                    value={this.state.lrForm.nameOfShipBuilder}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Name of Shipowner{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Name of Shipowner"
                                    name="nameOfShipOwner"
                                    value={this.state.lrForm.nameOfShipOwner}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Date of Delivery{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div
                                    className="input-group add-on date datepicker"
                                    data-date-format="yyyy-mm-dd"
                                  >
                                    <input
                                      type="text"
                                      value={this.state.lrForm.dateOfDelivery}
                                      className="form-control date-picker"
                                      placeholder="Date of Delivery"
                                      name="POFromDate"
                                    ></input>
                                    <DatePicker
                                      onChange={this.handleDeliveryDateChange}
                                      open={this.state.DeliveryDateOpen}
                                      onClickOutside={this.handleBlur}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      popperPlacement="top-end"
                                      className="form-control date-picker w-5 hide-date"
                                    />
                                    <div
                                      className="input-group-btn calendar-icon"
                                      onClick={this.openDeliveryDatePicker}
                                    >
                                      <button
                                        className="btn btn-default"
                                        style={{ height: "100%" }}
                                      >
                                        <i className="fa fa-calendar mt-1"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    IHM Inventory Number{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="IHM Inventory Number"
                                    name="ihmInventoryNumber"
                                    value={this.state.lrForm.ihmInventoryNumber}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane
                                      ? "col-lg-6 mb-2"
                                      : "col-lg-4 mb-2"
                                  }
                                >
                                  <label className="form-label">
                                    Issue Number{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Issue Number"
                                    name="issueNumber"
                                    value={this.state.lrForm.issueNumber}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <label className="ml-3">
                                  This inventory was developed in accordance
                                  with the IMO Guidelines for the Development of
                                  the Inventory of Hazardous Materials.{" "}
                                </label>
                                <div
                                  className={
                                    showSidePane ? "col-lg-12" : "col-lg-12"
                                  }
                                >
                                  <input
                                    type="checkbox"
                                    placeholder="Issue Number"
                                    name="isIhmDeveloped"
                                    checked={this.state.lrForm.isIhmDeveloped}
                                    onChange={(e) =>
                                      this.handleCheckBoxChange(e)
                                    }
                                  ></input>
                                  <span className="ml-3">
                                    If the IHM has been developed to cover
                                    additional requirements of the EU Ship
                                    Recycling Regulation (EU) 1257/2013 please
                                    check this box.{" "}
                                  </span>
                                </div>
                                <div className="col-lg-12 mt-3">
                                  <strong style={{ fontSize: "20px" }}>
                                    Initially prepared by:{" "}
                                  </strong>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Name <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Name"
                                    name="nameOfPreparer"
                                    value={this.state.lrForm.nameOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Company{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Company"
                                    name="companyOfPreparer"
                                    value={this.state.lrForm.companyOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Address{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Address"
                                    name="addressOfPreparer"
                                    value={this.state.lrForm.addressOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Position{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Position"
                                    name="positionOfPreparer"
                                    value={this.state.lrForm.positionOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Date <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div
                                    className="input-group add-on date datepicker"
                                    data-date-format="yyyy-mm-dd"
                                  >
                                    <input
                                      type="text"
                                      value={
                                        this.state.lrForm.dateOfPreparation
                                      }
                                      className="form-control date-picker"
                                      placeholder="Date"
                                      name="POFromDate"
                                    ></input>
                                    <DatePicker
                                      onChange={
                                        this.handlePreparationDateChange
                                      }
                                      open={this.state.PreparationDateOpen}
                                      onClickOutside={this.handleBlur}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      popperPlacement="top-end"
                                      className="form-control date-picker w-5 hide-date"
                                    />
                                    <div
                                      className="input-group-btn calendar-icon"
                                      onClick={this.openPreparationDatePicker}
                                    >
                                      <button
                                        className="btn btn-default"
                                        style={{ height: "100%" }}
                                      >
                                        <i className="fa fa-calendar mt-1"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Initials{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Initials"
                                    name="initialOfPreparer"
                                    value={this.state.lrForm.initialOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div className="col-lg-12 mt-3">
                                  <strong style={{ fontSize: "20px" }}>
                                    Designated person(s) responsible for the
                                    inventory{" "}
                                  </strong>
                                </div>
                                <div className="col-lg-12 mt-2">
                                  <div className="row">
                                    <div className="col-lg-11">
                                      <table className="material-decalaration-table table table-responsive">
                                        <tr>
                                          <th>
                                            Name
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </th>
                                          <th>
                                            Position
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </th>
                                          <th>
                                            Initials
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </th>
                                          <th>
                                            Start Date
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                            <br></br> ( YYYY-MM-DD )
                                          </th>
                                          <th>
                                            End date<br></br> ( YYYY-MM-DD )
                                          </th>
                                        </tr>
                                        {this.state.persons &&
                                          this.state.persons.map(
                                            (item, index) => {
                                              return (
                                                <tr>
                                                  <td
                                                    className="text-center"
                                                    contentEditable="true"
                                                    onBlur={(e) =>
                                                      this.handleTableEvent(
                                                        e,
                                                        index,
                                                        "name"
                                                      )
                                                    }
                                                  >
                                                    {item.name}
                                                  </td>
                                                  <td
                                                    className="text-center"
                                                    contentEditable="true"
                                                    onBlur={(e) =>
                                                      this.handleTableEvent(
                                                        e,
                                                        index,
                                                        "position"
                                                      )
                                                    }
                                                  >
                                                    {item.position}
                                                  </td>
                                                  <td
                                                    className="text-center"
                                                    contentEditable="true"
                                                    onBlur={(e) =>
                                                      this.handleTableEvent(
                                                        e,
                                                        index,
                                                        "initials"
                                                      )
                                                    }
                                                  >
                                                    {item.initials}
                                                  </td>
                                                  <td
                                                    className="text-center"
                                                    contentEditable="true"
                                                    onBlur={(e) =>
                                                      this.handleTableEvent(
                                                        e,
                                                        index,
                                                        "startDate"
                                                      )
                                                    }
                                                  >
                                                    {item.startDate}
                                                  </td>
                                                  <td
                                                    className="text-center"
                                                    contentEditable="true"
                                                    onBlur={(e) =>
                                                      this.handleTableEvent(
                                                        e,
                                                        index,
                                                        "endDate"
                                                      )
                                                    }
                                                  >
                                                    {item.endDate}
                                                  </td>
                                                  <td className="text-center">
                                                    <button
                                                      className="btn btn-primary text-uppercase txtht-btn blue text-center"
                                                      style={{
                                                        minHeight: "30px",
                                                      }}
                                                      onClick={(e) =>
                                                        this.handleDeleteEvent(
                                                          e,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      Delete
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                      </table>
                                    </div>
                                    <div className="col-lg-1">
                                      <button
                                        className="btn btn-primary text-uppercase txtht-btn blue"
                                        style={{ minHeight: "34px" }}
                                        type="submit"
                                        onClick={(e) => this.handleAddEvent(e)}
                                      >
                                        Add{" "}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Accordion.Collapse>
                        </Card>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>

              <div className="search-filter-box pb-0">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Certificates & Documents
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">HKC </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="HKC"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.hkcFilename}
                      />
                      {this.state.hkcFilename !== "" ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearHKC()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">EUSSR </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="EUSSR"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.eussrFilename}
                      />
                      {this.state.eussrFilename !== "" ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearEUSSR()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">IHM Full Manual </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="fullManual"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.fullManualFilename}
                      />
                      {this.state.fullManualFilename !== "" ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearIHM()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">
                      HKC Issued Date
                    </label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.hkcIssuedDate}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        // selected={this.state.SelectedFromDate}
                        onChange={this.handleHKCFromDateChange}
                        open={this.state.hkcFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile
                          ? "top-end"
                          : showSidePane
                            ? "top-end"
                            : "bottom"
                          }`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openHKCFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">
                      HKC Expiry Date
                    </label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={this.state.shipData.hkcExpiryDate}
                        type="text"
                        placeholder="Expiry Date"
                        className="form-control date-picker"
                        name="POToDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        // selected={this.state.SelectedToDate}
                        onChange={this.handleHKCToDateChange}
                        open={this.state.hkcToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openHKCToDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">EUSSR Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.euSSRIssuedDate}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        // selected={this.state.SelectedFromDate}
                        onChange={this.handleEUSSRFromDateChange}
                        open={this.state.eussrFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile
                          ? "top-end"
                          : showSidePane
                            ? "bottom-start"
                            : "bottom"
                          }`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openEUSSRFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">EUSSR Expiry Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={this.state.shipData.euSSRExpiryDate}
                        type="text"
                        placeholder="Expiry Date"
                        className="form-control date-picker"
                        name="POToDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        // selected={this.state.SelectedToDate}
                        onChange={this.handleEUSSRToDateChange}
                        open={this.state.eussrToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openEUSSRToDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-4" : "col-lg-2"}
                    style={{ minWidth: "19%" }}
                  >
                    <label className="form-label">
                      Full Manual Issued Date
                    </label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={this.state.shipData.fullmannualIssuedDate}
                        type="text"
                        placeholder="Issued Date"
                        className="form-control date-picker"
                        name="POFromDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        // selected={this.state.SelectedToDate}
                        onChange={this.handleIHMFromDateChange}
                        open={this.state.ihmFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openIHMFromDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Flag SOC </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="SOC"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.flagSocFilename}
                      />
                      {this.state.flagSocFilename !== "" ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearSOC()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">IAPP </label>
                    <br></br>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="IAPP"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="No file chosen"
                        value={this.state.iappFilename}
                      />
                      {this.state.iappFilename !== "" ? (
                        <div
                          className="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearIAPP()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Exemption Certificate </label>
                    <br></br>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="ec"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="No file chosen"
                        value={this.state.ecFilename}
                      />
                      {this.state.ecFilename !== "" ? (
                        <div
                          className="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.Clearec()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">Flag SOC Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.flagIssuedDate}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handleFlagSocFromDateChange}
                        open={this.state.flagSocFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile
                          ? "top-end"
                          : showSidePane
                            ? "bottom-start"
                            : "bottom"
                          }`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openFlagSocFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">Flag SOC Expiry Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={this.state.shipData.flagExpiryDate}
                        type="text"
                        placeholder="Expiry Date"
                        className="form-control date-picker"
                        name="POToDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        onChange={this.handleFlagSocToDateChange}
                        open={this.state.flagSocToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openFlagSocToDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">IAPP Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.iappIssuedDate}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handleiappFromDateChange}
                        open={this.state.iappFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile
                          ? "top-end"
                          : showSidePane
                            ? "bottom-start"
                            : "bottom"
                          }`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openiappFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">IAPP Expiry Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={this.state.shipData.iappExpiryDate}
                        type="text"
                        placeholder="Expiry Date"
                        className="form-control date-picker"
                        name="POToDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        onChange={this.handleiappToDateChange}
                        open={this.state.iappToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openiappToDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">EC Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.ecIssuedDate}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handleecFromDateChange}
                        open={this.state.ecFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile
                          ? "top-end"
                          : showSidePane
                            ? "bottom-start"
                            : "bottom"
                          }`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openecFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">EC Valid Till</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.ecExpiryDate}
                        className="form-control date-picker"
                        placeholder="Valid Till"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handleecToDateChange}
                        open={this.state.ecToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openecToDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Last Drydock Asbestos Free Declaration{" "}
                    </label>
                    <br></br>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="ldafd"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="No file chosen"
                        value={this.state.ldafdFilename}
                      />
                      {this.state.ldafdFilename !== "" ? (
                        <div
                          className="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.Clearldafd()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Asbestos Management Plan{" "}
                    </label>
                    <br></br>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="amp"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="No file chosen"
                        value={this.state.ampFilename}
                      />
                      {this.state.ampFilename !== "" ? (
                        <div
                          className="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.Clearamp()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}></div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Last Drydock Asbestos Free Declaration Issued Date
                    </label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.ldafdIssuedDate}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handleldafdFromDateChange}
                        open={this.state.ldafdFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openldafdFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="search-filter-box pb-0">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Ship Contact Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Ship Email</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="shipEmail"
                      placeholder="Ship Email"
                      value={this.state.shipData.shipEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Ship Contact Number 1</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="phone1"
                      placeholder="Ship Contact Number 1"
                      value={this.state.shipData.phone1}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Ship Contact Number 2</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="phone2"
                      placeholder="Ship Contact Number 2"
                      value={this.state.shipData.phone2}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Invoice Forwarding Email
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="invoiceForwardingEmail"
                      placeholder="Invoice Forwarding Email"
                      value={this.state.shipData.invoiceForwardingEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Vessel Group Email</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="vesselGroupEmail"
                      placeholder="Vessel Group Email"
                      value={this.state.shipData.vesselGroupEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Designated Person</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="designatedPerson"
                      placeholder="Designated Person"
                      value={this.state.shipData.designatedPerson}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="search-filter-box pb-0">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Company Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Company Name</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="clientName"
                      value={this.state.shipData.clientName}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Company Name</option>
                      {CompanyNames &&
                        CompanyNames.map((company) => (
                          <option value={company}>{company}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Fleet Manager</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="fleetManager"
                      value={this.state.fleetManager}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Fleet Manager</option>
                      {CompanyUsers &&
                        CompanyUsers.fleetManager.map((user1) => (
                          <option value={user1}>{user1}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Technical Superintendent
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="technicalSuperintendent"
                      value={this.state.technicalSuperintendent}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Technical Superintendent</option>
                      {CompanyUsers &&
                        CompanyUsers.superintendent.map((user2) => (
                          <option value={user2}>{user2}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Technical Executive</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="technicalExecutive"
                      value={this.state.technicalExecutive}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Technical Executive</option>
                      {CompanyUsers &&
                        CompanyUsers.technicalExecutive.map((user3) => (
                          <option value={user3}>{user3}</option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              {/* <div className="search-filter-box">
                                <div className="card MM-card-header" style={{ backgroundColor: "white" }}>
                                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Contract</h5></div>
                                </div>
                                <div className="row search-filter-box">
                                    <div className="col-lg-4">
                                        <label className="form-label">Contract Name</label><br></br>
                                        <input className="form-control" name="contractName" value={this.state.contractName} placeholder="Contract Name" onChange={e => this.handleContractInputChange(e)} disabled></input>
                                    </div>
                                    <div className="col-lg-8">
                                        <label className="form-label">Contract Status</label><br></br>
                                        <div className="row col-sm-12">
                                            <div className="radio">
                                                <input type="radio" checked={this.state.Pending} value="Pending" onChange={e => this.handleContractInputChange(e)} disabled={this.state.Pending ? false : true}></input>
                                                <span className="ml-1 mr-3">Pending</span>
                                            </div>
                                            <div className="radio">
                                                <input type="radio" checked={this.state.Active} value="Active" onChange={e => this.handleContractInputChange(e)} disabled={this.state.Active ? false : true}></input>
                                                <span className="ml-1 mr-3">Active</span>
                                            </div>
                                            <div className="radio">
                                                <input type="radio" checked={this.state.Terminated} value="Terminated" onChange={e => this.handleContractInputChange(e)} disabled={this.state.Terminated ? false : true}></input>
                                                <span className="ml-1 mr-3">Terminated</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              <div className="search-filter-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Hazardous Materials
                    </h5>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 ml-4">
                      <label className="form-label">
                        Upload Revision Document :{" "}
                      </label>
                      <br></br>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            Browse File
                            <input
                              type="file"
                              style={{ marginRight: 40 }}
                              id="files"
                              title=" "
                              name="fileName"
                              onChange={(e) => this.handleInputChange(e)}
                              onClick={(event) => {
                                event.currentTarget.value = null;
                              }}
                            />
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="No file chosen"
                          value={this.state.revisionFilename}
                        />
                        {this.state.revisionFilename ? (
                          <div
                            class="input-group-append"
                            style={{ cursor: "pointer" }}
                          >
                            <i
                              class="fa fa-times input-group-text"
                              aria-hidden="true"
                              onClick={() => this.ClearInput()}
                            ></i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4 ml-4">
                      <label className="form-label">
                        Upload Inventory Data :{" "}
                      </label>
                      <br></br>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            Browse File
                            <input
                              type="file"
                              id="files"
                              style={{ marginRight: 40 }}
                              title=" "
                              name="inventoryName"
                              onChange={(e) => this.handleInputChange(e)}
                              onClick={(event) => {
                                event.currentTarget.value = null;
                              }}
                            />
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="No file chosen"
                          value={this.state.inventoryFilename}
                        />
                        {this.state.inventoryFilename ? (
                          <div
                            class="input-group-append"
                            style={{ cursor: "pointer" }}
                          >
                            <i
                              class="fa fa-times input-group-text"
                              aria-hidden="true"
                              onClick={() => this.ClearInputs()}
                            ></i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="search-filter-box pb-0 mt-1">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2"
                          style={{ color: "092a51" }}
                        >
                          Paint & Coating Systems
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showRightPanel(1)}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderPaintCoating()}
                    </div>
                  </div>
                  <div className="search-filter-box pb-0">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2"
                          style={{ color: "092a51" }}
                        >
                          Equipment & Machinery
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showRightPanel(2)}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderEquipmentMachinery()}
                    </div>
                  </div>
                  <div className="search-filter-box pb-0">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2"
                          style={{ color: "092a51" }}
                        >
                          Structure & Hull
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showRightPanel(3)}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderStructureHull()}
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2"
                          style={{ color: "092a51" }}
                        >
                          Stores
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showRightPanel(4)}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderStores()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-12 pb-2">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.SubmitData()}
                    >
                      {" "}
                      Submit{" "}
                    </button>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderPaintCoating = () => {
    const { showSidePane, PaintCoatingList } = this.props;
    return (
      <>
        {PaintCoatingList && PaintCoatingList.length ? (
          PaintCoatingList.map((item, index) => {
            return (
              <div
                className="card MM-card-content"
                style={{
                  backgroundColor: "#eee",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div className={`row `}>
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Application : </strong>
                              <span className="italicFont ">
                                {item.application}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                          {/* </div>
                                            <div className="row"> */}
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity{" "}
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={showSidePane ? "col-sm-6" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"col-sm-3 col-md-2 col-2 col-m-auto"}>
                        <div className="text-center">
                          <i
                            className="fa fa-edit fa-2x fa-lg click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.EditMaterials(1, item)}
                          ></i>
                          <i
                            className="fa fa-trash fa-2x click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.DeletePopup(1, index)}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card mb-0"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Items</h6>
            </div>
          </div>
        )}

        {/* {PaintCoatingList && PaintCoatingList.length ? (
                    <Paginator
                        first={this.state.activePagePaintCoating}
                        rows={this.state.rows}
                        totalRecords={PaintCoatingList ? PaintCoatingList.length : 0}
                        onPageChange={(e) => this.handlePaintCoatingPageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card mb-0" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Items
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
    // }) : null
  };
  renderEquipmentMachinery = () => {
    const { showSidePane, EquipmentMachineryList } = this.props;
    return (
      <>
        {EquipmentMachineryList && EquipmentMachineryList.length ? (
          EquipmentMachineryList.map((item, index) => {
            return (
              <div
                className="card MM-card-content"
                style={{
                  backgroundColor: "#eee",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div className={`row `}>
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                          {/* </div>
                                            <div className="row"> */}
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={showSidePane ? "col-sm-6" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"col-sm-3 col-md-2 col-2 col-m-auto"}>
                        {/* <div className="text-center">
                                                <i className="fa fa-edit fa-2x fa-lg click p-2" aria-hidden="true" style={{ color: " #1E3A8A", marginLeft: '-15px' }} onClick={() => this.EditMaterials(2, item)}></i>
                                            </div> */}
                        <div className="text-center">
                          <i
                            className="fa fa-edit fa-2x fa-lg click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.EditMaterials(2, item)}
                          ></i>
                          <i
                            className="fa fa-trash fa-2x click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.DeletePopup(2, index)}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card mb-0"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Items</h6>
            </div>
          </div>
        )}

        {/* {EquipmentMachineryList && EquipmentMachineryList.length ? (
                    <Paginator
                        first={this.state.activePageEquipment}
                        rows={this.state.rows}
                        totalRecords={EquipmentMachineryList ? EquipmentMachineryList.length : 0}
                        onPageChange={(e) => this.handleEquipmentPageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card mb-0" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Items
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
  };
  renderStructureHull = () => {
    const { showSidePane, StructureHullList } = this.props;
    return (
      <>
        {StructureHullList && StructureHullList.length ? (
          StructureHullList.map((item, index) => {
            return (
              <div
                className="card MM-card-content"
                style={{
                  backgroundColor: "#eee",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div className={`row `}>
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                          {/* </div>
                                            <div className="row"> */}
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={showSidePane ? "col-sm-6" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"col-sm-3 col-md-2 col-2 col-m-auto"}>
                        {/* <div className="text-center">
                                                <i className="fa fa-edit fa-2x fa-lg click p-2" aria-hidden="true" style={{ color: " #1E3A8A", marginLeft: '-15px' }} onClick={() => this.EditMaterials(3, item)}></i>
                                            </div> */}
                        <div className="text-center">
                          <i
                            className="fa fa-edit fa-2x fa-lg click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.EditMaterials(3, item)}
                          ></i>
                          <i
                            className="fa fa-trash fa-2x click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.DeletePopup(3, index)}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card mb-0"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Items</h6>
            </div>
          </div>
        )}

        {/* {StructureHullList && StructureHullList.length ? (
                    <Paginator
                        first={this.state.activePageStructure}
                        rows={this.state.rows}
                        totalRecords={StructureHullList ? StructureHullList.length : 0}
                        onPageChange={(e) => this.handleStructurePageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card mb-0" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Items
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
  };
  renderStores = () => {
    const { showSidePane, StoreList } = this.props;
    return (
      <>
        {StoreList && StoreList.length ? (
          StoreList.map((item, index) => {
            return (
              <div
                className="card MM-card-content"
                style={{
                  backgroundColor: "#eee",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div className={`row `}>
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                          {/* </div>
                                            <div className="row"> */}
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={showSidePane ? "col-sm-6" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"col-sm-3 col-md-2 col-2 col-m-auto"}>
                        {/* <div className="text-center">
                                                <i className="fa fa-edit fa-2x fa-lg click p-2" aria-hidden="true" style={{ color: " #1E3A8A", marginLeft: '-15px' }} onClick={() => this.EditMaterials(4, item)}></i>
                                            </div> */}
                        <div className="text-center">
                          <i
                            className="fa fa-edit fa-2x fa-lg click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.EditMaterials(4, item)}
                          ></i>
                          <i
                            className="fa fa-trash fa-2x click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.DeletePopup(4, index)}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card mb-0"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Items</h6>
            </div>
          </div>
        )}

        {/* {StoreList && StoreList.length ? (
                    <Paginator
                        first={this.state.activePageStore}
                        rows={this.state.rows}
                        totalRecords={StoreList ? StoreList.length : 0}
                        onPageChange={(e) => this.handleStoresPageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card mb-0" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Items
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
  };

  EditMaterials(id, item) {
    this.props.dispatch({ type: "EditMaterial", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    if (id === 1) {
      this.props.dispatch({ type: "GetPaintCoatingDetails", data: item });
      this.props.history.push("/Home/Management/ShipAdd/PaintCoating");
    } else if (id === 2) {
      this.props.dispatch({ type: "GetEquipmentMachineryDetails", data: item });
      this.props.history.push("/Home/Management/ShipAdd/EquipmentMachinery");
    } else if (id === 3) {
      this.props.dispatch({ type: "GetStructureHullDetails", data: item });
      this.props.history.push("/Home/Management/ShipAdd/StructureHull");
    } else if (id === 4) {
      this.props.dispatch({ type: "GetStoreDetails", data: item });
      this.props.history.push("/Home/Management/ShipAdd/Stores");
    }
    window.scrollTo(0, 0);
  }

  DeletePopup(id, index) {
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.deleteMaterials(id, index);
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  }

  deleteMaterials = (id, index) => {
    const {
      PaintCoatingList,
      EquipmentMachineryList,
      StructureHullList,
      StoreList,
    } = this.props;
    if (id === 1) {
      PaintCoatingList.splice(index, 1);
      this.setState({});
    } else if (id === 2) {
      EquipmentMachineryList.splice(index, 1);
      this.setState({});
    } else if (id === 3) {
      StructureHullList.splice(index, 1);
      this.setState({});
    } else if (id === 4) {
      StoreList.splice(index, 1);
      this.setState({});
    }
    // window.scrollTo(0, 0);
  };
  showRightPanel(id) {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditMaterial", data: false });
    if (id === 1) {
      this.props.dispatch({ type: "GetPaintCoatingDetails", data: null });
      this.props.history.push("/Home/Management/ShipAdd/PaintCoating");
    } else if (id === 2) {
      this.props.dispatch({ type: "GetEquipmentMachineryDetails", data: null });
      this.props.history.push("/Home/Management/ShipAdd/EquipmentMachinery");
    } else if (id === 3) {
      this.props.dispatch({ type: "GetStructureHullDetails", data: null });
      this.props.history.push("/Home/Management/ShipAdd/StructureHull");
    } else if (id === 4) {
      this.props.dispatch({ type: "GetStoreDetails", data: null });
      this.props.history.push("/Home/Management/ShipAdd/Stores");
    }
    window.scrollTo(0, 0);
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    HKCAttachment: state.MasterScreenReducer.HKCAttachment,
    EUSSRAttachment: state.MasterScreenReducer.EUSSRAttachment,
    FullManualAttachment: state.MasterScreenReducer.FullManualAttachment,
    FlagSOCAttachment: state.MasterScreenReducer.FlagSOCAttachment,
    IAPPAttachment: state.MasterScreenReducer.IAPPAttachment,
    AMPAttachment: state.MasterScreenReducer.AMPAttachment,
    ECAttachment: state.MasterScreenReducer.ECAttachment,
    LDSFAAttachment: state.MasterScreenReducer.LDSFAAttachment,
    showSidePane: state.SidePanReducer.sidePan,
    PaintCoatingList: state.MasterScreenReducer.PaintCoatingList || [],
    EquipmentMachineryList:
      state.MasterScreenReducer.EquipmentMachineryList || [],
    StructureHullList: state.MasterScreenReducer.StructureHullList || [],
    StoreList: state.MasterScreenReducer.StoreList || [],
    CompanyNames: state.MasterScreenReducer.CompanyNames,
    CompanyUsers: state.MasterScreenReducer.CompanyUsers,
    attachmentDetail: state.ShipViewReducer.attachmentDetail,
    inventoryDetail: state.ShipViewReducer.inventoryDetail,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipManagementNewItem)
);
